import type { StrapiMagazineArticle } from '~/composables/types/strapi/strapi-magazine'

const STATE_KEY = 'magazineArticleData'

export const useMagazineArticleStore = () => {
  const data = useState<StrapiMagazineArticle | null>(STATE_KEY, () => null)

  const set = (value: StrapiMagazineArticle | null) => {
    data.value = value
  }

  const clearIfOwner = (ownedValue: StrapiMagazineArticle | null) => {
    if (data.value === ownedValue) {
      data.value = null
    }
  }

  return {
    data,
    set,
    clearIfOwner,
  }
}
